import CryptoJS from "crypto-js";
import { db } from "../model";
// import { validateJwtToken } from "../../utils/methods";

const key = process.env.OFFLINE_PASSWORD_KEY;

async function encryptPassword(password) {
  return CryptoJS.AES.encrypt(password, key).toString();
}

async function decryptPassword(encryptedPassword) {
  const bytes = CryptoJS.AES.decrypt(encryptedPassword, key);
  return bytes.toString(CryptoJS.enc.Utf8);
}

async function storeUser(email, username, password, refreshToken=null) {
  // const encryptedPassword = await encryptPassword(password);
  const user = await db.users.where("email").equals(email).first();
  if (!user) {
    await db.users.add({ email, username, password, refreshToken });
    return "User information stored offline.";
  } else {
    db.users.where("id").equals(user.id).modify({ email, username, password, refreshToken });
    return "user already exists in the db";
  }
}

async function getUsernameFromEmail(email) {
  const user = await db.users.where("email").equals(email).first();

  if (user) {
    return user;
  } else {
    return "No User";
  }
}

async function checkCrediantials(email, password) {
  const user = await db.users.where("email").equals(email).first();

  if (user) {
    const decryptedPassword = user.password;
    // Once refresh token implemented use if (valid) {} istead of if (password === decryptedPassword) {}
    // const { valid, expireIn } = validateJwtToken(user.refreshToken)

    if (password === decryptedPassword) {
    // if (valid) {
      return "User authenticated.";
    } else {
      return "Invalid password";
    }
  } else {
    return "User not found.";
  }
}

export { getUsernameFromEmail, storeUser, checkCrediantials };
